import React from 'react';
import Image from 'next/image'
import { sanitizeHTML } from "@/lib/utils";

interface WelcomeAboutNonAnimatedData {
  heading?: {
    text?: string;
    title?: string;
  };
  text?: {
    id: string;
    site_content_id: {
      text: string;
    };
  }[];
}

export const fields = [
  "heading.text",
  "heading.title",
  
  "text.id",
  "text.site_content_id.text",
] as const;

interface WelcomeAboutNonAnimatedProps {
  zIndex: number;
  thresholds: number[][];
  mobileThresholds: number[][];
  transitionTime?: number;
  helperRotation?: number;
  data?: WelcomeAboutNonAnimatedData;
}

export default function WelcomeAboutNonAnimated({ zIndex, thresholds, mobileThresholds, transitionTime, helperRotation, data }: WelcomeAboutNonAnimatedProps) {
  return (

    <section className="w-full bg-primary lg:bg-white">
      <div className="container mx-auto px-7 md:px-0 py-8 md:py-16">
        <div className="flex flex-col items-center gap-5 lg:gap-8">
          <h2 className="text-[2rem] font-essonnes font-light leading-tight md:text-5xl lg:text-[3.375rem] text-white lg:text-primary text-center max-w-[62rem]">
            {data?.heading?.title}
          </h2>
          
          {data?.text && data.text.map((textItem, index) => (
            <React.Fragment key={textItem.id}>
              {index > 0 && (
                <Image
                  src="/images/logo-shape.svg"
                  alt="Decorative Icon"
                  width={41}
                  height={42}
                  className="w-4 h-4 md:w-[2.5rem] md:h-[2.5rem]"
                />
              )}
              <div 
                className="text-[1rem] font-normal leading-normal lg:text-[1.125rem] text-white lg:text-primary font-greycliff md:leading-loose tracking-tight text-center max-w-[76rem] [&>p]:pb-8 [&_a]:underline [&_a:hover]:no-underline"
                dangerouslySetInnerHTML={sanitizeHTML(textItem?.site_content_id?.text)}
              />
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  )
} 